import camelCase from 'lodash/camelCase'
import capitalize from 'lodash/capitalize'
import { objectKeysToCamelCase } from '@/helpers/transform-object-keys'

export default {
  props: {
    sharing: {
      type: Object,
      required: true
    }
  },

  computed: {
    formattedSharing() {
      return objectKeysToCamelCase(this.sharing)
    },

    webShareApiButtonLabel() {
      return this.formattedSharing.webShareApi.buttonLabel
    }
  },

  methods: {
    shareButtonComponentForChannel(channel) {
      return `${capitalize(channel.medium)}Button`
    },

    sharingOptionsForChannel(channel) {
      return this.formattedSharing[camelCase(channel.kind)]
    }
  }
}
